import careerGrowth from '../../../data/Homepage/careerGrowth.json'
import CareerGrowthPNG from '../../../assets/HomePage/CareerGowth/careerGowth.png'
import ProfileSvg from '../../../assets/HomePage/CareerGowth/Profile.svg'
import CalenderSvg from '../../../assets/HomePage/CareerGowth/Calaneder.svg'
import RoleSvg from '../../../assets/HomePage/CareerGowth/Role.svg'

export const CareerGrowth = () => {
  return (
    <section className="w-full bg-[#ffffff] min-h-[800px] py-12 px-6 md:px-20 lg:px-24 xl:px-36">
      {/* <div className="flex md:flex md:justify-center space-x-10 items-center"> */}
        <div className="flex flex-col lg:flex-row justify-center items-center lg:space-x-10 space-y-8 lg:space-y-0">
        {/* <div> */}
        <div className="text-center lg:text-left space-y-5">
          <h2 className="text-2xl sm:text-3xl lg:text-[48px] lg:w-[600px] text-[#2C25C4] space-y-4 ">
            <p>Why <span className="font-bold">CareerConnect Ai</span></p>
            <p>is Right Choice for you?</p>
          </h2>
          <p className="text-base sm:text-lg lg:text-[20px] text-gray-500">
            Our AI Powers Smarter Hiring & Career Growth for All
          </p>
          <div>
            <img
              src={CareerGrowthPNG}
              alt="Our AI Powers Smarter Hiring"
              className="mx-auto lg:mx-0 h-[250px] sm:h-[320px] lg:h-[408px]"
            />
          </div>
        </div>

        <div>
          {careerGrowth?.careerGrowth.length > 0 ? (
            <div className="flex flex-col gap-3 items-center w-full">
              {careerGrowth.careerGrowth.map((career, index) => {
                return (
                  <div
                    key={index}
                    className="bg-white shadow h-auto sm:h-[84px] w-full sm:w-[403px] rounded-lg p-2 flex gap-2 items-center"
                  >
                    <img
                      src={career.icon}
                      alt={career.heading}
                      className={`${career.color}w-10 h-10 rounded-xl p-2 bg-primary-200`}
                    />
                    <div className="flex flex-col">
                      <h2 className="font-semibold text-sm sm:text-base">{career.heading}</h2>
                      <p className="text-sm text-gray-500">{career.content}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:justify-evenly md:items-center mt-10 py-5 px-5 md:px-20 space-y-5 md:space-y-0 md:space-x-5">
        {/* Card 1 */}
        <div className="flex gap-1 items-center justify-start space-x-3 bg-white hover:bg-violet-100 border-gray-100 border-[0.5px] shadow-md w-full md:w-60 rounded-xl ">
          <div className="w-20 h-20 bg-[#9E26FE] rounded-xl shadow-lg flex items-center justify-center">
            <img src={ProfileSvg} alt="Profiles" />
          </div>
          <div className="ml-2">
            <h2 className="font-bold text-xl md:text-2xl">1 Lakh+</h2>
            <p className="text-xs">Profiles</p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="flex gap-1 items-center justify-start space-x-3 bg-white hover:bg-green-100 border-gray-100 border-[0.5px] shadow-sm w-full md:w-60 rounded-xl ">
          <div className="w-20 h-20 bg-[#00B143] rounded-xl shadow-lg flex items-center justify-center">
            <img src={CalenderSvg} alt="Industry experience" />
          </div>
          <div className="ml-2">
            <h2 className="font-bold text-xl md:text-2xl">7+ years</h2>
            <p className="text-xs">Industry experience</p>
          </div>
        </div>

        {/* Card 3 */}
        <div className="flex gap-2 items-center justify-start space-x-3 hover:bg-blue-100 bg-white border-gray-100 border-[0.5px] shadow-md w-full md:w-60 rounded-xl ">
          <div className="w-20 h-20 bg-[#1863FD] rounded-xl shadow-lg flex items-center justify-center">
            <img src={RoleSvg} alt="Job roles" />
          </div>
          <div className="ml-2">
            <h2 className="font-bold text-xl md:text-2xl">10k +</h2>
            <p className="text-xs">Job roles</p>
          </div>
        </div>
      </div>
    </section>
  )
}
